import { ResponsiveLine } from '@nivo/line'
import { numberFormat } from '@labrav/common'
import {
  themeForRevenueLineGraph,
  useStyles,
} from './ListingInteractions.styles'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { useSelector } from '../../../../store'
import { CustomLegends } from '../../../FlyoutOverview/CustomLegends/CustomLegends'
import { MetricsData } from '../../../../modules/storefrontMetrics/reducer'
import { Typography } from '@mui/material'

export const ListingInteractions = () => {
  const { classes } = useStyles()
  const theme = useTheme()
  const lineGraphTheme = themeForRevenueLineGraph(
    theme.palette.labraText.description
  )
  const { graphData } = useSelector<MetricsData>(
    state => state.storefrontMetricsData
  )
  const listingsInteractionsData = graphData || []
  return (
    <>
      <div data-testid={'revenue-chart'} className={classes.root}>
        <div
          className={classes.legendsWrapper}
          data-testid={'custom-legend-wrapper'}
        >
          <CustomLegends
            legends={[
              {
                label: 'Impressions',
                legendColor: theme.palette.awsGraph.main,
                legendSize: 'medium',
              },
              {
                label: 'Clicks',
                legendColor: theme.palette.microsoftGraph.main,
                legendSize: 'medium',
              },
              {
                label: 'Forms submitted',
                legendColor: theme.palette.gcpGraph.main,
                legendSize: 'medium',
              },
            ]}
          />
        </div>
        <div
          className={classes.responsiveLineWrapper}
          data-testid={'responsive-line-chart'}
        >
          <ResponsiveLine
            data={listingsInteractionsData}
            theme={lineGraphTheme}
            curve="catmullRom"
            margin={{ top: 30, right: 15, bottom: 65, left: 35 }}
            xScale={{ type: 'point' }}
            yScale={{
              type: 'linear',
              stacked: false,
            }}
            gridYValues={5}
            axisBottom={{
              tickSize: 0,
              tickPadding: 10,
              legendOffset: 55,
              legendPosition: 'middle',
              tickValues: 5,
            }}
            axisLeft={{
              tickSize: 0,
              tickPadding: 10,
              legendOffset: -40,
              tickValues: 5,
              legendPosition: 'middle',
              format: value => numberFormat(value),
            }}
            pointSize={5}
            pointBorderColor={{ from: 'serieColor' }}
            useMesh={true}
            colors={[
              theme.palette.awsGraph.main,
              theme.palette.microsoftGraph.main,
              theme.palette.gcpGraph.main,
            ]}
            tooltip={point => {
              const interactionName = getIntrectionName(
                point?.point.serieId as string
              )
              const value = numberFormat(Number(point.point.data.yFormatted))
              return (
                <div className={classes.tooltip}>
                  {interactionName && (
                    <Typography>{interactionName} :</Typography>
                  )}
                  {value}
                </div>
              )
            }}
          />
        </div>
      </div>
    </>
  )
}

export const getIntrectionName = (cloud: string) => {
  if (cloud === 'impressions') {
    return 'Impressions'
  }

  if (cloud === 'clicks') {
    return 'Clicks'
  }

  if (cloud === 'forms_Submitted') {
    return 'Forms Submitted'
  }

  return ''
}
